<template>
  <div class="webnew-page">
    <div class="webnew-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="webnew-page-navigate-body position-relative">
        <div class="webnew-page-navigate-body-content safe-with">
          <p class="font-bold font-36 font-color-fff">追思缅怀</p>
        </div>
      </div>
    </div>
    <div v-if="cateAry.length" class="webnew-page-list">
      <div class="webnew-page-list-body safe-with flex">
        <div class="webnew-page-list-body-left flex-shrink">
          <div class="webnew-page-list-body-left-body">
            <div v-for="(item, index) in cateAry" :key="index" class="webnew-page-list-body-left-body-item flex-row-center cursor" :class="cateIndex==index?'sel':''" @click="newCateTap(index)">
              <p class="font-14">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="webnew-page-list-body-right flex-1">
          <div class="webnew-page-list-body-right-tit flex-row-center-between">
            <p class="font-bold font-16">{{ cateAry[cateIndex].name }}</p>
            <p v-if="pageType == 1" class="font-12">{{ list.length }}条</p>
            <p v-else class="font-12 cursor" @click="returnList">返回列表</p>
          </div>
          <div v-if="pageType == 1">
            <div v-if="list.length">
              <div class="webnew-page-list-body-right-list">
                <div v-for="(item, index) in list" :key="index" class="webnew-page-list-body-right-list-item flex-row-center cursor" @click="toLink(index)">
                  <div v-if="item.coverImg" class="img flex-shrink" :style="{backgroundImage: 'url(' + item.coverImg + ')'}" />
                  <div v-else class="img flex-shrink default-img-cover" />
                  <div class="text flex-column-between">
                    <span class="pre">
                      <p class="font-bold font-16 text-line-1">{{ item.title }}</p>
                      <p class="font-14 text-line-2">{{ item.des }}</p>
                    </span>
                    <span class="bottom flex-row-center">
                      <p class="font-12">{{ item.createTime }}</p>
                      <p v-if="item.source" class="font-12">来源：{{ item.source }}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="webnew-page-list-body-right-list-page flex-center">
                <el-pagination
                  background
                  :page-size="20"
                  layout=" prev, pager, next"
                  :total="pages"
                  @current-change="pageChage"
                />
              </div>
            </div>
            <div v-else class="webnew-page-list-body-right-error flex-column-center">
              <img src="../../assets/img/icon-list-error.png">
              <p class="font-14 font-color-999">暂无数据</p>
            </div>
          </div>
          <div v-else class="webnew-page-list-body-right-html">
            <p class="font-24 webnew-page-list-body-right-html-tit">{{ list[curIndex].title }}</p>
            <p class=" webnew-page-list-body-right-html-time flex-row-center">
              <span class="font-14">发布时间：{{ list[curIndex].createTime }}</span>
              <span v-if="list[curIndex].source" class="font-14">来源：{{ list[curIndex].source }}</span>
            </p>
            <p class="font-14" v-html="htmlStr" />
            <div v-if="curIndex<list.length - 1" class="webnew-page-list-body-right-html-bottom flex-row-center cursor">
              <p class="font-14" @click="toNext">下一篇：{{ list[curIndex + 1].title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import { parseHtml } from '@/utils/bmpgl.js'
import { getShowPath } from '@/utils/imgpath'
export default {
  data() {
    return {
      list: [],
      currPage: 1,
      pages: 10,
      cateIndex: 0,
      cateAry: this.$store.getters.catelog || [],
      pageType: 1,
      htmlStr: '',
      curIndex: 0,

      cateId: 0,
      sourceId: 0
    }
  },
  watch: {
    $route(to, from) {
      const id = this.$route.query.sourceId ?? 0
      if (this.sourceId !== id) {
        this.sourceId = id
      }
      this.cateId = this.$route.query.cateId ?? 0
      if (this.cateId !== 0) {
        this.cateIndex = this.cateAry.findIndex(v => v.code === this.cateId)
      }
      this.request()
    }
  },
  created() {
    this.cateId = this.$route.query.cateId ?? 0
    this.sourceId = this.$route.query.sourceId ?? 0
    this.requestCatalog()
  },
  methods: {
    async requestCatalog() {
      const res = await api.getListByParentId({ parentId: 959 })
      if (res.code === 2000) {
        this.cateAry = res.items
      }
      if (this.cateId !== 0) {
        this.cateIndex = this.cateAry.findIndex(v => v.code === this.cateId)
      }
      this.request()
    },
    request() {
      api.news({
        catalogId: this.cateAry[this.cateIndex].code,
        limit: 20,
        page: this.currPage
      }).then(res => {
        if (res.code === 2000) {
          this.pages = res.items.totalCount
          res.items.data.forEach(value => {
            value.des = value.content.replace(/<.+?>/g, '')
            value.des = parseHtml(value.des)
            if (value.coverImg) {
              value.coverImg = getShowPath('img', value.coverImg)
            }
          })
          this.list = res.items.data
          if (this.sourceId !== 0) {
            const index = this.list.findIndex(v => String(v.id) === this.sourceId)
            if (index >= 0) {
              console.error('Find It', index)
              this.checkDetail(index)
            }
          }
        }
      })
    },
    returnList() {
      this.pageType = 1
      // this.htmlStr = ''
      // this.curIndex = 0
      this.$router.back()
    },
    checkDetail(index) {
      this.curIndex = index
      this.htmlStr = this.list[index].content
      this.pageType = 0
    },
    toLink(index) {
      this.$router.push({
        path: '/webnews',
        query: {
          cateId: this.cateAry[this.cateIndex].code,
          sourceId: this.list[index].id
        }
      })
    },
    pageChage(v) {
      this.currPage = v
      this.request()
      window.scrollTo(0, 0)
    },
    newCateTap(val) {
      console.error(val, this.cateIndex)
      if (this.cateIndex === val) {
        return
      }
      this.pageType = 1
      this.cateIndex = val
      this.$router.push({
        path: '/webnews',
        query: {
          cateId: this.cateAry[this.cateIndex].code
        }
      })
    },
    toNext() {
      this.curIndex += 1
      this.toLink(this.curIndex)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
  .webnew-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .webnew-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .webnew-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .webnew-page-navigate-body-content {
    padding-top: 120px;
  }

  .webnew-page-navigate-body-content p {
    line-height: 80px;
  }

  .webnew-page-list-body-right {
    margin-left: 30px;
  }

  .webnew-page-list-body-right-tit {
    margin-top: 10px;
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .webnew-page-list-body-right-tit p:last-child {
    color: #767676;
  }

  .webnew-page-list-body-left {
    width: 220px;
  }

  .webnew-page-list-body-right-list {
    padding-top: 20px;
  }

  .webnew-page-list-body-right-list-item {
    margin-bottom: 30px;
  }

  .webnew-page-list-body-right-list-item:last-child {
    margin-bottom: 0;
  }

  .webnew-page-list-body-right-list-item .img {
    width: 200px;
    height: 140px;
    border-radius: 5px;
    margin-right: 20px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .webnew-page-list-body-right-list-item .text {
    height: 140px;
  }

  .webnew-page-list-body-right-list-item .text .bottom p{
    line-height: 30px;
    color: #767676;
    margin-right: 10px;
  }

  .webnew-page-list-body-right-list-item .text .pre p:last-child {
    color: #1A1A1A;
    line-height: 25px;
  }

  .webnew-page-list-body-right-list-item .text .pre p:first-child {
    line-height: 30px;
  }

  .webnew-page-list-body-right-list-page {
    margin: 60px 0;
  }

  .webnew-page-list-body-left-body {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.03) 100%);
  }

  .webnew-page-list-body-left-body-item {
    height: 50px;
    border-image: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%) 0 0 1 0;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    padding: 0 20px;
  }

  .webnew-page-list-body-left-body-item.sel p{
    font-weight: bold;
  }

  .webnew-page-list-body-right-error {
    height: 500px;
    justify-content: center;
  }

  .webnew-page-list-body-right-error img {
    margin-bottom: 10px;
  }

  .webnew-page-list-body-right-html {
    padding: 40px 0;
  }

  .webnew-page-list-body-right-html-bottom {
    margin-top: 60px;
    border-top: 1px solid #eee;
    height: 50px;
  }

  .webnew-page-list-body-right-html-bottom p {
    color: #1A1A1A;
  }

  .webnew-page-list-body-right-html-tit {
    line-height: 36px;
    color: #1A1A1A;
    font-weight: bold;
  }

  .webnew-page-list-body-right-html-time {
    margin-bottom: 30px;
  }

  .webnew-page-list-body-right-html-time span {
    line-height: 30px;
    color: #767676;
    margin-right: 20px;
  }

</style>
